module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL2-if-one-correct.5ead0a1d.mp3";